import { render } from "./system-attachments.vue?vue&type=template&id=611bf4d6&ts=true"
import script from "./system-attachments.vue?vue&type=script&lang=ts"
export * from "./system-attachments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__